import { createAsyncThunk,createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TimeOffPolicyStateClass } from "./interfaces/TimeOffPoliciesStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import { sortData } from "../../../common/timeLiveFunction";

const initialState : TimeOffPolicyStateClass ={
    isLoading:false,
    status : "idle",
    isReload : false,
    selectedRecord:{},
    timeOffPolicyList:[],
    sortOrder: 'asc',
    sortColumn: 'AccountTimeOffPolicy',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi{
    state:{
        timeOffPolicy:TimeOffPolicyStateClass
    }
}




export const getTimeOffPoliciesAsync = createAsyncThunk
<any,void,IThunkApi>
(
    "TimeOffPolicies/V2/getTimeOffPolicies",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/TimeOffPolicies","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }

)

export const getTimeOffPolicyByTimeOffPolicyIdAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "TimeOffPolicies/V2/getTimeOffPolicyByTimeOffPolicyId",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/TimeOffPolicies/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const addTimeOffPolicyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "TimeOffPolicies/V2/addTimeOffPolicy",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/TimeOffPolicies/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const updateTimeOffPolicyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "TimeOffPolicies/V2/updateTimeOffPolicy",
    async (arg,thunkApi)=>{
        const {AccountTimeOffPolicyId,...argWithoutId} = arg;
        const response = await fetchAPI("api/V2/TimeOffPolicies/UpdateRecordWithDetails/"+AccountTimeOffPolicyId,"PUT",argWithoutId,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)

export const deleteTimeOffPolicyAsync = createAsyncThunk
<any,any,IThunkApi>
(
    "TimeOffPolicies/V2/deleteTimeOffPolicy",
    async (arg,thunkApi)=>{
        const response = await fetchAPI("api/V2/TimeOffPolicies/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        return json;
    }
)
// export const ResendVerificationEmailAsync = createAsyncThunk
// <any,any,IThunkApi>
// (
//     "Employees/ResendVerificationEmail",
//     async (arg,thunkApi)=>{
//         const response = await fetchAPI("api/Employees/ResendVerificationEmail/" + arg,"POST","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
//         const json = response.json();
//         return json;
//     }

// )
export const DeleteSelectedTimeOffPoliciesAsync = createAsyncThunk
<any, any, IThunkApi>
(
    "TimeOffPolicies/v2/DeleteSelectedTimeOffPolicies",
    async (arg, thunkApi) => {
        // const response = await fetchAPI('api/Expenses/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const response = await fetchAPI('api/v2/TimeOffPolicies/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json = await response.json();
        return json;

    }
)

const timeOffPolicySlice = createSlice({
    name:"timeOffPolicy",
    initialState,
    reducers:{
        resetSelectedRecordObjectInState:(state)=>{
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            
            
            const currentindex = Object.values(state.timeOffPolicyList).findIndex((item : any) => item.AccountTimeOffPolicyId == action.payload);
            const newArray = [...Object.values(state.timeOffPolicyList)];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.timeOffPolicyList = newArray;
            
        },
        unCheckedState: (state, action) => {
            
            const currentindex = Object.values(state.timeOffPolicyList).findIndex((item : any) => item.AccountTimeOffPolicyId == action.payload);

            const newArray = [...Object.values(state.timeOffPolicyList)];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.timeOffPolicyList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = Object.values(state.timeOffPolicyList).map((item : any) => ({
                ...item,
                isSelected: 1,
            }));
            state.timeOffPolicyList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = Object.values(state.timeOffPolicyList).map((item : any) => ({
                ...item,
                isSelected: 0,
            }));
            state.timeOffPolicyList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.timeOffPolicyList;
            // console.log('data1',action.payload.sortOrder)
            // console.log('data2',action.payload.sortColumn)
            // console.log('data3',state.timeOffPolicyList)
             state.timeOffPolicyList = sortData(Object.values(tempArray), action.payload.sortOrder, action.payload.sortColumn);
        }

    },
    extraReducers:(builder) =>{
        builder
        .addCase(getTimeOffPoliciesAsync.pending,(state)=>{
            state.status = "loading";
            state.isLoading = true;
        })
        .addCase(getTimeOffPoliciesAsync.fulfilled,(state,{payload})=>{
            state.status = "idle";
          
            if (Object.keys(payload.Data).length === 0) {
                state.timeOffPolicyList = [];
            } else {
                state.timeOffPolicyList = payload.Data;
                Object.values(state.timeOffPolicyList).map((timeOffPolicyDetails : any) => 
                    timeOffPolicyDetails.isSelected = 0
                )
    
            }
            state.isReload = false;
            state.selectedRecord = {};
            state.isLoading = false;
          
        })
        .addCase(getTimeOffPoliciesAsync.rejected,(state)=>{
            state.status = "failed";
            state.isLoading = false;
        })

        .addCase(getTimeOffPolicyByTimeOffPolicyIdAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(getTimeOffPolicyByTimeOffPolicyIdAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
          
            state.selectedRecord = payload.Data;
            state.isLoading = false;
            
            
        })
        .addCase(getTimeOffPolicyByTimeOffPolicyIdAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(addTimeOffPolicyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;

        })
        .addCase(addTimeOffPolicyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(addTimeOffPolicyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(updateTimeOffPolicyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(updateTimeOffPolicyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';        
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(updateTimeOffPolicyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

        .addCase(deleteTimeOffPolicyAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(deleteTimeOffPolicyAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;
        })
        .addCase(deleteTimeOffPolicyAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })

       
        .addCase(DeleteSelectedTimeOffPoliciesAsync.pending, (state) => {
            state.status = 'loading';
            state.isLoading = true;
        })
        .addCase(DeleteSelectedTimeOffPoliciesAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            state.isReload = true;
            state.isLoading = false;

        })
        .addCase(DeleteSelectedTimeOffPoliciesAsync.rejected, (state) => {
            state.status = 'failed';
            state.isLoading = false;
        })
        
    }
})

export const {resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting} = timeOffPolicySlice.actions
export const TimeOffPolicystate = (state : RootState)=>state.timeOffPolicy
export default timeOffPolicySlice.reducer


